// reducer.js
/*eslint-disable*/
import { FETCH_FACEBOOK_DATA_FAILURE, FETCH_FACEBOOK_DATA_REQUEST, FETCH_FACEBOOK_DATA_SUCCESS } from './actionCreator';

const initialState = {
  posts: [],
  loading: false,
  error: null,
};

const facebookPostReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FACEBOOK_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_FACEBOOK_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        posts: action.payload,
        error: null,
      };
    case FETCH_FACEBOOK_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default facebookPostReducer;
